function initSwiper(loopMode = true, autoPlayMode = true) {
  return new Swiper(".main-swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: loopMode,
    speed: 3000,
    autoplay: autoPlayMode
      ? { delay: 0, disableOnInteraction: false }
      : false,
    wrapperClass: 'main-wrapper',
    slideClass: 'main-media',
    breakpoints: {
      300: { slidesPerView: 1, spaceBetween: 0 },
      768: { slidesPerView: 2.5, spaceBetween: 0 },
      1024: { slidesPerView: 2.5, spaceBetween: 0 },
      1440: { slidesPerView: 2.5, spaceBetween: 0 },
    },
  });
}

var swipermain = initSwiper(true, true);
const swiperEl = document.querySelector('.main-swiper');
swiperEl.addEventListener('mouseenter', () => {
  swipermain.autoplay.stop();
});
swiperEl.addEventListener('mouseleave', () => {
  swipermain.autoplay.start();
});
$(".image-popup-vertical-fit").magnificPopup({
    type: "image",
    mainClass: "mfp-with-zoom",
    gallery: { enabled: !0 },
    zoom: {
        enabled: !0,
        duration: 300,
        easing: "ease-in-out",
        opener: function (e) {
            return e.is("img") ? e : e.find("img");
        },
    },
})

$(document).on('change', '.variant-picker__option-values input[type="radio"]', function () {
  console.log("Variant changed (raw):", this.value);

  var variantTitle = $(this).val()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ') 
    .replace(/["']/g, '');  
  var $targetSlide = $('.main-media[data-color="' + variantTitle + '"]');

  if ($targetSlide.length) {
    var $link = $targetSlide.find('.image-popup-vertical-fit');

    if ($link.length) {
      $link.trigger('click');
    }
  } else {
    console.log("❌ No matching slide for:", variantTitle);
  }
   $('.absolute_btn_wrap').addClass('active');
});

$(document).on('click', '.mfp-close', function () {
  $('.absolute_btn_wrap').removeClass('active');
});

$(document).on('click', '.mfp-content', function () {
  $('.absolute_btn_wrap').removeClass('active');
});

$(document).on('click', '.absolute_btn.primary_btn', function (e) {
  e.preventDefault(); 
  $('.eascStickyAddToCartBtn').trigger('click');
});

jQuery(document).ready(function ($) {
  var $priceUpdate = $('.price_update');
    var $checkedInput = $('input[name="option1"]:checked');
    if ($checkedInput.length) {
      var labelForChecked = $('label[for="' + $checkedInput.attr('id') + '"]');
      var initialPriceHTML = labelForChecked.data('price');
      if (initialPriceHTML) {
        $priceUpdate.html(initialPriceHTML);
        console.log('Initial variant price:', initialPriceHTML);
      }
    }
  $('.block-swatch').on('click', function () {
    var priceHTML = $(this).data('price');
    if (priceHTML) {
        $priceUpdate.html(priceHTML);
        console.log('Variant price updated to:', priceHTML);
    }

    // 🔥 Trigger corresponding craft-tab-item
    var index = $(this).index('.block-swatch');
    var $targetTab = $('.craft-tab-item').eq(index);

    console.log('Swatch index:', index, '-> targeting tab:', $targetTab.text());

    if ($targetTab.length) {
        $('.craft-tab-item').removeClass('active');
        $targetTab.addClass('active');  // ensure active state
        $targetTab.trigger('click');    // fire its click too (if handler exists)
    }
});
});

function truncateHTMLContent(selector = '.product_description', wordLimit = 23) {
  $(selector).each(function () {
    const $el = $(this);
    if ($el.data('truncated')) return;

    const fullHtml = $el.html().trim();
    if (!fullHtml) return;

    const $tempDiv = $("<div>").html(fullHtml);
    let wordCount = 0;
    let isTruncated = false;

    function processNode(node) {
      let visiblePart = '';
      let hiddenPart = '';

      if (wordCount >= wordLimit) {
        hiddenPart += node.outerHTML || node.textContent || '';
        return { visible: '', hidden: hiddenPart };
      }

      if (node.nodeType === 3) { // text
        const words = node.textContent.trim().split(/\s+/).filter(Boolean);
        if (!words.length) return { visible: '', hidden: '' };

        if (wordCount + words.length <= wordLimit) {
          wordCount += words.length;
          return { visible: node.textContent, hidden: '' };
        } else {
          const remaining = wordLimit - wordCount;
          const visibleText = words.slice(0, remaining).join(' ') + ' ';
          const hiddenText = words.slice(remaining).join(' ') + ' ';
          wordCount = wordLimit;
          isTruncated = true;
          return { visible: visibleText, hidden: hiddenText };
        }
      }

      if (node.nodeType === 1) { // element
        const tag = node.tagName.toLowerCase();
        const attrs = [...node.attributes].map(a => ` ${a.name}="${a.value}"`).join('');
        const openTag = `<${tag}${attrs}>`;
        const closeTag = `</${tag}>`;

        let childVisible = '';
        let childHidden = '';

        $(node).contents().each(function () {
          const { visible, hidden } = processNode(this);
          childVisible += visible;
          childHidden += hidden;
        });

        return {
          visible: childVisible ? openTag + childVisible + closeTag : '',
          hidden: childHidden ? openTag + childHidden + closeTag : ''
        };
      }

      return { visible: '', hidden: '' };
    }

    let visibleHtml = '';
    let hiddenHtml = '';

    $tempDiv.contents().each(function () {
      const { visible, hidden } = processNode(this);
      visibleHtml += visible;
      hiddenHtml += hidden;
    });

    if (isTruncated) {
      $el.html(`
        ${visibleHtml}<span class="dots">...</span>
        <span class="more-text" style="display:none;">${hiddenHtml}</span>
        <a href="#" class="read-more-toggle" style="cursor:pointer;">Read more</a>
      `);
      $el.data('truncated', true);
    }
  });

  // toggle
  $(document).off('click', '.read-more-toggle').on('click', '.read-more-toggle', function (e) {
    e.preventDefault();
    const $el = $(this).closest(selector);
    const $moreText = $el.find('.more-text');
    const $dots = $el.find('.dots');
    const isExpanded = $moreText.is(':visible');

    if (isExpanded) {
      $moreText.hide();
      $dots.show();
      $(this).text('Read more');
    } else {
      $moreText.show();
      $dots.hide();
      $(this).text('Read less');
    }
  });
}

// run
$(document).ready(function () {
  truncateHTMLContent();
});
$(document).on('content-loaded', function () {
  truncateHTMLContent();
});
